import {initModules} from '#/modules/registry'
import {setCaps, getCaps} from '#/modules/caps'
import {fetchSessionCaps} from '#/horizon/handshake'

declare global {
  // eslint-disable-next-line no-var
  var __HORIZON_BOOTSTRAPPED__: boolean | undefined
  // eslint-disable-next-line no-var
  var __HORIZON_MODULE_CTX__:
    | {origin: string; isLoggedIn: boolean; caps: Record<string, boolean>}
    | undefined

  // NOTE: __HORIZON_SLOTS__ is declared in slots.ts. Do not redeclare it here.
  // NOTE: __HORIZON_ACTIVE_MODULES__ is declared/owned by registry.ts. Do not redeclare it here.
}

function getCtx() {
  return (
    globalThis.__HORIZON_MODULE_CTX__ ?? {
      origin: 'app://unknown',
      isLoggedIn: false,
      caps: {},
    }
  )
}

export function bootstrapModules(origin: string) {
  // Deny-by-default until the server says otherwise.
  const seeded: Record<string, boolean> = {}
  setCaps(seeded)

  if (!globalThis.__HORIZON_BOOTSTRAPPED__) {
    globalThis.__HORIZON_BOOTSTRAPPED__ = true
    globalThis.__HORIZON_MODULE_CTX__ = {origin, isLoggedIn: false, caps: seeded}
    void initModules(globalThis.__HORIZON_MODULE_CTX__!)
  } else {
    refreshModules({origin, caps: seeded})
  }

  // If/when isLoggedIn flips true later, the caller should invoke refreshModules({isLoggedIn:true})
  // and we will fetch real caps there.
}

export function refreshModules(
  patch: Partial<{
    origin: string
    isLoggedIn: boolean
    caps: Record<string, boolean>
  }>,
) {
  const prev = getCtx()

  // If caller explicitly provides caps, use them as-is.
  const explicitCaps = patch.caps
  const next = {...prev, ...patch, caps: explicitCaps ?? getCaps()}

  globalThis.__HORIZON_MODULE_CTX__ = next

  // Kick module sync immediately with whatever we currently know.
  void initModules(globalThis.__HORIZON_MODULE_CTX__!)

  // If we are logged in and caps were NOT explicitly provided, fetch authoritative caps.
  // This is Option C: server decides reality.
  if (explicitCaps == null && next.isLoggedIn === true) {
    void (async () => {
      try {
        const caps = await fetchSessionCaps()
        setCaps(caps)
        globalThis.__HORIZON_MODULE_CTX__ = {...getCtx(), caps}
        void initModules(globalThis.__HORIZON_MODULE_CTX__!)
      } catch (err) {
        // Fail closed: no caps, no Hideaway UI.
        console.warn('[hideaway] caps handshake failed; disabling caps', err)
        setCaps({})
        globalThis.__HORIZON_MODULE_CTX__ = {...getCtx(), caps: {}}
        void initModules(globalThis.__HORIZON_MODULE_CTX__!)
      }
    })()
  }
}
;(globalThis as any).Horizon = {
  refreshModules,
  setCaps,
  getCaps,
}
bootstrapModules(
  typeof window !== 'undefined' ? window.location.origin : 'app://unknown'
)
